import { format, subDays, addDays } from 'date-fns';
import { TTimeDuration } from './dateType';

interface IGetTimeRegistrationAccuracy {
  startDate: string;
  endDate: string;
}

export const getStartAndEndDateRange = (
  timeRegisterType: TTimeDuration,
): IGetTimeRegistrationAccuracy => {
  const today = format(new Date(), 'yyyy-MM-dd');

  switch (timeRegisterType) {
    case 'weekly':
      return {
        startDate: format(subDays(new Date(), 6), 'yyyy-MM-dd'),
        endDate: today,
      };
    case 'biWeekly':
      return {
        startDate: format(subDays(new Date(), 13), 'yyyy-MM-dd'),
        endDate: today,
      };
    case 'monthly':
      return {
        startDate: format(subDays(new Date(), 29), 'yyyy-MM-dd'),
        endDate: today,
      };
    default:
      return {
        startDate: format(addDays(new Date(), 7), 'yyyy-MM-dd'),
        endDate: today,
      };
  }
};
